<template>
  <div :class="['borders', boardInfo.NSVuln ? 'nsVuln' : 'nsNonVuln', boardInfo.EWVuln ? 'ewVuln' : 'ewNonVuln' ]">

    <div :class="['number', small ? 'small' : 'large']">{{ number }}</div>

    <div v-if="!small" :class="['dea' + ['N', 'E', 'S', 'W'][boardInfo.dealer], 'dealer']"></div>

  </div>
</template>

<script>

import {getBoardInfo} from "../../lib/bridgeUtils";

export default {
  name: "DealStatus",
  props: {
    number: {
      required: true
    },
    small: {
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    boardInfo() {
      return getBoardInfo(this.number);
    }
  },
  methods: {},
}
</script>

<style scoped>

.borders {
  border: 10px solid;
  display: flex;
}

.nsVuln {
  border-top-color: red;
  border-bottom-color: red;
}

.nsNonVuln {
  border-top-color: green;
  border-bottom-color: green;
}

.ewVuln {
  border-left-color: red;
  border-right-color: red;
}

.ewNonVuln {
  border-left-color: green;
  border-right-color: green;
}

.dealer {
  border-radius: 10px;
  background-color: #428bca;
  width: 15px;
  height: 15px;
  position: absolute;
}

.deaN {
  top: 15px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}

.deaE {
  right: 30px;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.deaS {
  bottom: 15px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}

.deaW {
  left: 30px;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.number {
  text-align: center;
  width: 100%
}

.large {
  padding: 6px 0;
  min-width: 7rem;
  font-size: 4rem;
}

.small {
  padding: 2px 0;
  font-size: 2rem;
}

</style>
